import React, { useEffect, useCallback, useState} from 'react';
import FigureScreen from './FigureScreen.js';
import TrackScreen from './TrackScreen.js';
import {FIGURE, TRACK} from './constants.js';
import {connect} from 'react-redux';
import Rules from './Rules.js';

const Screen = ({setChosen, effect, track, sequencerEngine, chosen}) => { 
    if (!chosen) {
        return (<Rules track={track} sequencerEngine={sequencerEngine} effect={effect}/>);
    }
    return (
        <div
          onClick={(e) => track ? e.stopPropagation() : ''}
          className="screen">
        {chosen.type === FIGURE &&
         <FigureScreen setChosen={setChosen} effect={effect} chosen={chosen}/>}
        {chosen.type === TRACK &&
         <TrackScreen setChosen={setChosen} effect={effect} track={chosen.track}/>}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Screen);
